import { supabase } from '../supabaseClient';

/* Esemény az events táblába, saját sorként (az RLS a saját user_id-t engedi).
   Hiba esetén csendben kimarad: a mérés soha nem állítja meg a felületet. */
export function track(session, name, props = {}) {
  supabase.from('events').insert({ user_id: session?.user?.id ?? null, event_name: name, properties: props })
    .then(() => undefined, () => undefined);
}
